<template>
  <div class="achievement-container">
  	<div class="achievement-table">
  		<div class="achievement-success">
  			<div class="achievement-number">{{studentScore}}</div>
  		</div>
  		<div v-show="this.passStatus == 2" class="achievement-text">成功上岸</div>
  		<div v-show="this.passStatus != 2" class="achievement-text1">再接再厉</div>
  		<div class="achievement-explain">
  			<div class="achievement-explain-table">
  				<div class="achievement-exp-number">{{answerTime}}</div>
  				<div class="achievement-exp-text">答题时长</div>
  			</div>
  			<div class="achievement-explain-table">
  				<div class="achievement-exp-number">{{trueCount}}</div>
  				<div class="achievement-exp-text">答对题目</div>
  			</div>
  			<div class="achievement-explain-table">
  				<div class="achievement-exp-number">{{trueRate}}%</div>
  				<div class="achievement-exp-text">正确率</div>
  			</div>
  		</div>
  		<div class="achievement-btn">
        <a href="javascript:;" v-show="watchAnswer!=1" @click="exitClick" class="achivenment-btn-back">确&nbsp;&nbsp;&nbsp;定</a>
  			<a href="javascript:;" v-show="watchAnswer==1" @click="exitClick" class="achievement-btn-all">确&nbsp;&nbsp;&nbsp;定</a>
  			<a href="javascript:;" v-show="watchAnswer==1" @click="toAnalysis" class="achivenment-btn-error">查看解析</a>
  		</div>
  	</div>
  </div>
</template>

<script>
  import {getUrlKey} from '../../untils/common.js'
  import {ApiGetExamResult} from '../../net/exam/index.js'
  export default {
    data: function () {
      return {
        examId: 0,
        uid: 1103,
        studentName: '',
        studentScore: 0,
        trueCount: 0,
        answerTime: '',
        trueRate: 0,
        retakeCount: 0,
        passStatus: 1,
        watchAnswer: 2,
        }
    },
    computed:{
      fractionClass: function() {
        return this.passStatus == 2?'Results_fraction_success':'Results_fraction_fail'
      },
      gradeColor: function () {
        return this.passStatus == 2?'#56CB70':'#E74F4F'
      },
    },
    methods: {
      toAnalysis: function () {
        this.$router.push(`/Analysis?eid=${this.examId}`)
      },
      exitClick: function () {
        this.$router.push('/AccExam')
      },
      getResult: function () {
        const params = {
          examId: this.examId,
          uid: this.uid
          }
        ApiGetExamResult(params).then(res=>{
          // console.log(res)
          if (res.code == 200) {
            this.studentName = res.value.studentName
            this.studentScore = res.value.studentScore
            this.trueCount = res.value.trueCount
            this.answerTime = res.value.answerTime
            this.trueRate = res.value.trueRate
            this.retakeCount = res.value.retakeCount
            this.passStatus = res.value.passStatus
            this.watchAnswer = res.value.watchAnswer
          }
        }).catch(err=>{
          // console.log('err',err)
        })
      }
    },
    mounted: function () {
       this.examId = getUrlKey('eid',window.location.href) || 0
       this.getResult()
       // console.log(this.examId)
    }
  }
</script>

<style scoped>
  .achievement-container{
  	width: 1140px;
  	margin:0 auto;
  	background: #fff;
  	border-radius: 6px;
  	margin-top: 24px;
  	min-height: 600px;
  	overflow: hidden;
  }
  .achievement-table{
  	width: 440px;
  	margin: 0 auto;
  	margin-top: 40px;
  	margin-bottom: 40px;
  	border-radius: 6px;
  	border:10px solid #e5e5e5;
  	padding-top: 50px;
  	padding-bottom: 50px;
  }
  .achievement-success{
  	background-image: url(../../assets/img/grades-bgimg.png);
  	width: 240px;
  	height: 194px;
  	margin:0 auto;
  	background-size: 240px 200px;
  	overflow: hidden;
  }
  .achievement-number{
  	font-size: 40px;
  	color: #fff;
  	text-align: center;
  	margin-top: 57px;
  	font-weight: bold;
  	text-shadow: 0 1px 10px rgba(0,0,0,.15);
  }
  .achievement-text{
  	font-size: 30px;
  	text-align: center;
  	font-weight: bold;
  	color: #0AAC50;
  	padding-bottom: 20px;
  	width: 350px;
  	margin:0 auto;
  	margin-top: 20px;
  	margin-bottom: 10px;
  }
  .achievement-text1{
  	font-size: 30px;
  	text-align: center;
  	font-weight: bold;
  	color: #454545;
  	padding-bottom: 20px;
  	width: 350px;
  	margin:0 auto;
  	margin-top: 20px;
  	margin-bottom: 10px;
  }
  .achievement-explain{
  	width: 330px;
  	margin: 0 auto;
  	padding: 30px 10px 30px 10px;
  	background: #f5f5f5;
  	border-radius: 6px;
  	overflow: hidden;
  }
  .achievement-explain-table{
  	width: 110px;
  	text-align: center;
  	float: left;
  }
  .achievement-exp-number{
  	font-size: 16px;
  	color: #252525;
  	line-height: 1.5;
  }
  .achievement-exp-text{
  font-size: 14px;
  color: #999;
  margin-top: 5px;
  line-height: 1.5;
  }
  .achievement-btn{
  	width: 340px;
  	margin:0 auto;
  	margin-top: 80px;
  	overflow: hidden;
  	margin-bottom: 50px;
  }
  .achievement-btn-all{
  	width:140px;
  	height: 40px;
  	background: #0AAC50;
  	border-radius: 6px;
  	text-align: center;
  	line-height: 40px;
  	float: left;
  	text-decoration: none;
  	color: #fff;
  	font-size: 16px;
  }
  .achievement-btn-all:hover{
  	background:#009640;
  }

  .achivenment-btn-back{
    display: block;
  	width:280px;
  	height: 40px;
  	background: #0AAC50;
  	border-radius: 6px;
  	text-align: center;
  	line-height: 40px;
  	text-decoration: none;
  	color: #fff;
  	font-size: 16px;
    margin: 0 auto;
  }
  achivenment-btn-back:hover{
  	background:#009640;
  }
  .achivenment-btn-error{
  	width:138px;
  	height: 38px;
  	border:1px solid  #0AAC50;
  	border-radius: 6px;
  	text-align: center;
  	line-height: 40px;
  	float: right;
  	text-decoration: none;
  	color: #0AAC50;
  	font-size: 16px;
  }
  .achivenment-btn-error:hover{
  	background:#009640;
  	color: #fff;
  	border:1px solid #009640;
  }
</style>



// WEBPACK FOOTER //
// src/components/Results/Results.vue